module.exports = "/_next/static/images/jaguar-2bdfab03183378eecdcbbc6a6b233326.png";